import { NextApiRequest, NextApiResponse } from "next";
import { Nullable } from "../../types";
import {
  ACCESS_TOKEN_COOKIE_NAME,
  IS_LOGGED_IN_COOKIE_NAME,
  REFRESH_TOKEN_COOKIE_NAME,
  VERIFYING_TOKEN_COOKIE_NAME,
} from "../../vars";

export const removeAuthCookies =
  (domain: string) =>
  async (req: NextApiRequest, res: NextApiResponse): Promise<Nullable<void>> => {
    try {
      res.setHeader(`Set-Cookie`, [
        `${ACCESS_TOKEN_COOKIE_NAME} =; max-age = -1; domain=.${domain}; path =/`,
        `${REFRESH_TOKEN_COOKIE_NAME} =; max-age = -1; domain=.${domain}; path =/`,
        `${IS_LOGGED_IN_COOKIE_NAME} =; max-age = -1; path=/`,
        `${VERIFYING_TOKEN_COOKIE_NAME} =; max-age = -1; path=/`,
      ]);
      // Send data from server response
      res.send({});
    } catch (err) {
      console.warn(err);
    }
  };
